import React, { useEffect, useRef } from 'react';
import './css/Ideas.css'; // Assuming you have a CSS file for additional styling

const Ideas = () => {
  const sectionsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    sectionsRef.current.forEach((section) => {
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      sectionsRef.current.forEach((section) => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  return (
    <div className="ideas-container">
      <div className="card idea" ref={(el) => (sectionsRef.current[0] = el)}>
        <div className="card-body">
          <h2 className="card-title">E-commerce Platform</h2>
          <p>An online platform for buying and selling products with features like product listings, shopping cart, payment gateway integration, and user reviews.</p>
          <img src="/path/to/ecommerce-platform-diagram.png" alt="E-commerce Platform Implementation Diagram" />
        </div>
      </div>
      
      <div className="card idea" ref={(el) => (sectionsRef.current[1] = el)}>
        <div className="card-body">
          <h2 className="card-title">Fitness Tracking App</h2>
          <p>A mobile app to track fitness activities, monitor health metrics, set fitness goals, and provide workout recommendations.</p>
          <img src="/path/to/fitness-tracking-app-diagram.png" alt="Fitness Tracking App Implementation Diagram" />
        </div>
      </div>
      
      <div className="card idea" ref={(el) => (sectionsRef.current[2] = el)}>
        <div className="card-body">
          <h2 className="card-title">Project Management Tool</h2>
          <p>A desktop application to manage projects, assign tasks, track progress, and collaborate with team members.</p>
          <img src="/path/to/project-management-tool-diagram.png" alt="Project Management Tool Implementation Diagram" />
        </div>
      </div>
    </div>
  );
};

export default Ideas;